import ReactConfetti, { IConfettiOptions } from 'react-confetti'
import { useWindowSize } from '~/hooks/useWindowSize'
import { classNames as cn } from '~/helpers/string'

export interface ConfettiProps extends Partial<IConfettiOptions> {
  className?: string
}

export function Confetti(props: ConfettiProps) {
  const { className = '', ...rest } = props
  const { width, height } = useWindowSize()

  if (!width || !height) return null

  return (
    <ReactConfetti
      width={width}
      height={height}
      recycle={false}
      numberOfPieces={400}
      opacity={0.4}
      className={cn('max-w-full', className)}
      {...rest}
    />
  )
}
